import React, { Component } from 'react'
import SRCards from '../../components/SRCards'
import { ThemeProvider } from '@material-ui/core/styles'
import { THEME } from '../../common/theme'
import LoginApi from '../../services/login.service'
import jwt_decode from "jwt-decode";

const apiservices = new LoginApi()

class Dashboard extends Component {
    async componentDidMount() {
        try {
            const token = await localStorage.getItem("google-token")
            if (token) {
                let userProfile: any = jwt_decode(token);
                const params = {
                    tokenId: token,
                    username: userProfile.email
                }
                const response = await apiservices.login(params);
            } else throw new Error("no token")
            
            // const response = await apiservices.login(params);
        } catch (error: any) {
            console.error(error)
            localStorage.clear();
            window.location.reload();
        }
    }
    render() {
        localStorage.setItem('page', '1')
        return (
            <ThemeProvider theme={THEME}>
                <SRCards />
            </ThemeProvider>
        )
    }
}

export default Dashboard;